import React, { useState, useRef } from "react";
import { Link as ReactLink, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Form, Button, Container, Row, Col, Spinner } from "react-bootstrap";
import { useAuthStore } from "../model";
import { login } from "../api";
import { getUserByToken } from "@/entities/user/api";
import PhoneInput from "react-phone-input-2";

import "react-phone-input-2/lib/bootstrap.css";
import { PasswordInputGroup } from "@/shared/ui";

export const LoginForm = () => {
  const [numberPhone, setNumberPhone] = useState("");
  const [password, setPassword] = useState("");
  const [validated, setValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const { setUser, setIsAuthorization } = useAuthStore();

  const buttonRef = useRef<HTMLButtonElement>(null);

  const isValidPhone = (phone: string) => {
    const digits = phone.replace(/\D/g, "");

    return (
      digits.length === 11 && (digits.startsWith("7") || digits.startsWith("8"))
    );
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setValidated(true);

    if (!numberPhone || !password) {
      enqueueSnackbar("Пожалуйста, заполните все поля.", { variant: "error" });
      buttonRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    if (!isValidPhone(numberPhone)) {
      console.log(isValidPhone(numberPhone));
      enqueueSnackbar("Введите корректный номер телефона.", {
        variant: "error",
      });
      buttonRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    setLoading(true);
    try {
      const data = await login({
        phone: numberPhone.replace(/^7/, "8"),
        password,
      });

      if (data.success) {
        localStorage.setItem("token", data.result);
        setIsAuthorization();
        navigate("/");
        enqueueSnackbar("Успешный вход!", { variant: "success" });

        const me = await getUserByToken(data.result);
        if (me) setUser(me.result);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="max-w-sm mx-auto">
      <Row className="justify-content-md-center mt-5">
        <Col xs={12} md={5} lg={4}>
          <h2 className="text-center mb-4">Вход</h2>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formPhone" className="mb-3">
              <Form.Label>Номер телефона</Form.Label>
              <PhoneInput
                country={"ru"}
                disableDropdown={true}
                specialLabel=""
                // countryCodeEditable={false}
                masks={{ ru: "(...) ...-..-.." }}
                onlyCountries={["ru"]}
                placeholder="Введите номер телефона"
                value={numberPhone}
                onChange={(phone) => {
                  if (phone.startsWith("8")) {
                    setNumberPhone(`7${phone.slice(1)}`);
                  } else {
                    setNumberPhone(phone);
                  }
                }}
                inputClass="form-control rounded-5"
              />
              <Form.Control.Feedback type="invalid">
                Введите корректный номер телефона.
              </Form.Control.Feedback>
            </Form.Group>

           <PasswordInputGroup
              label="Пароль"
              value={password}
              name="password"
              onChange={(e) => setPassword(e.target.value)}
              showPassword={showPassword}
              toggleShow={() => setShowPassword(!showPassword)}
              placeholder="Введите пароль"
              isInvalid={validated && !password}
              feedback="Пожалуйста, введите ваш пароль."
            />

            <Button
              ref={buttonRef}
              variant="outline-secondary"
              type="submit"
              className="w-100"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Вход...
                </>
              ) : (
                "Войти"
              )}
            </Button>
          </Form>

          <div className="text-center mt-3">
            <ReactLink to="/forgot" className="text-secondary">
              Забыли пароль?
            </ReactLink>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
